export default __webpack_public_path__ + "images/e405403c497c165ecfe9195294e5a681-EE_SlideDeckBOOK1024_2.png";